import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

type UtmStore = {
  utmData: Record<string, string>;
  setUtmData: (utmData: Record<string, string>) => void;
  clearUtmData: () => void;
};
export const useUtmStore = create<UtmStore>()(
  persist(
    (set) => ({
      utmData: {},
      setUtmData: (utmData) => {
        set({ utmData });
      },
      clearUtmData: () => {
        set({ utmData: {} });
      },
    }),
    { storage: createJSONStorage(() => localStorage), name: "twi.utmDataStore" },
  ),
);
